import type { ID } from '@octopus-do/octopus-project-core'
import {
  InternalThreadsActions,
  type ThreadsActions,
} from '@store/reducers/threads/actions'
import { selectSelectedThread } from '@storeOld/reducers/canvas/canvas'
import axios, { type AxiosResponse } from 'axios'
import { call, put, select } from 'redux-saga/effects'

import { GlobalActions } from '@/store'
import type { Thread } from '../types'

// todo: replace with API method
const fetchThreads = (projectId: string): Promise<AxiosResponse<any>> =>
  axios.get(`/threads/${projectId}`, {
    baseURL: import.meta.env.VITE_API_URL,
    headers: {
      'X-Auth-Token': localStorage.getItem('token'),
      'X-Password-Token': localStorage.getItem(`pw_${projectId}`),
    },
  })

export function* list({
  payload: { id },
}: ReturnType<typeof ThreadsActions.list>) {
  const selectedThread: ID | null = yield select(selectSelectedThread)
  const response: AxiosResponse<Thread[]> = yield call(fetchThreads, id)

  yield put(InternalThreadsActions.set(response.data))

  if (!selectedThread) {
    return
  }

  yield put(
    GlobalActions.jumpTo({ selector: 'data-jump-id', value: selectedThread })
  )
}
